import { render, staticRenderFns } from "./ticketUsuario.vue?vue&type=template&id=71dfbe8e"
import script from "./ticketUsuario.vue?vue&type=script&lang=js"
export * from "./ticketUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports